const LOCAL_FORAGE_ITEM_KEY = {
  SESSION_TOKEN: 'sessionToken',
};

export { LOCAL_FORAGE_ITEM_KEY };
